import React from 'react';
import { Col, Container } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import PrevisaoCargasComponent from './components/PrevisaoCargasComponent';

const PrevisaoCargas = () => {
  return <Container fluid>
      <Col md={12}>
        <PageHeader title="" routeSegments={[{
        name: 'Início',
        path: '/'
      }, {
        name: 'Previsão de Cargas',
        path: '/pages/previsao-cargas'
      }]} />
      </Col>
      <PrevisaoCargasComponent />
    </Container>;
};

export default PrevisaoCargas;
